import { FontSizes, FontWeights, getTheme, NeutralColors, SharedColors, Stack } from "@fluentui/react";
import * as React from "react";
import { useContext, useEffect, useState } from "react";
import { useOutletContext, useParams } from "react-router-dom";
import Card from "../Components/Card";
import AppContent from "../Surfaces/AppContent";
import AddPaymentSchedule from "../Panel/PaymentSchedule/AddPaymentSchedule";
import EditProject from "../Panel/Project/EditProject";
import AddPayment from "../Panel/Payment/AddPayment";
import AuthContext from "../Services/AuthContext";
import EditTransaction from "../Panel/Transaction/EditTransaction";
import AddProjectAddon from "../Panel/ProjectAddon/AddProjectAddon";
import AddProjectDocument from "../Panel/ProjectDocument/AddProjectDocument";
import PaymentList from "../Lists/PaymentList";
import ProjectDocumentList from "../Lists/ProjectDocumentList";
import ProjectAddonList from "../Lists/ProjectAddonList";
import PaymentScheduleList from "../Lists/PaymentScheduleList";
import GenerateProjectDocument from "../Panel/ProjectDocument/GenerateProjectDocument";
import InvoiceList from "../Lists/InvoiceList";
import ProjectCheckList from "../Lists/ProjectCheckList";
import AddChecklist from "../Panel/Checklist/AddChecklist";
import ProjectFeesList from "../Lists/ProjectFeesList";
import AddAdditionalFee from "../Panel/AdditionalFee/AddAdditionalFee";
import MergeProject from "../Panel/Project/MergeProject";
import DeleteProject from "../Panel/Project/DeleteProject";
import DeleteTransaction from "../Panel/Project/DeleteTransaction";
import ProjectTasks from "../Lists/ProjectTasks";
import ProjectCounterList from "../Lists/ProjectCounterList";
import { clearTextInfo, joinTextInfo } from "../Utilities/clearTextInfo";
import { netGrossField, netGrossFieldName, useNetGross } from "../Utilities/NetGrossField";

function Project(props) {
    const [user] = useContext(AuthContext);
    const netGross = useNetGross();
    const [payments, setPayments] = useState([]);
    const [fees, setFees] = useState([]);
    const [schedules, setSchedules] = useState([]);
    const [addons, setAddons] = useState([]);
    const [invoices, setInvoices] = useState([]);
    const [checklist, setChecklist] = useState([]);
    const [documents, setDocuments] = useState([]);
    const [tasks, setTasks] = useState([]);
    const [counters, setCounters] = useState([]);
    const [project, setProject] = useState([]);
    const [refresh, setRefresh] = useState(0);
    const params = useParams();
    useEffect(() => {
        const abortController = new AbortController();

        async function fetchData() {
            await fetch(`/api/project/${params.id}`, {
                method: "GET",
                signal: abortController.signal,
                headers: {
                    "Authorization": "Bearer " + user.token,
                },
            }).then(res => res.json())
                .then(data => {
                    setProject(data.header);
                    setPayments(data.payments);
                    setSchedules(data.schedule);
                    setAddons(data.addons);
                    setDocuments(data.documents);
                    setInvoices(data.invoices);
                    setChecklist(data.checklist);
                    setFees(data.fees);
                    setTasks(data.tasks);
                    setCounters(data.counters);
                }).catch(err => {
                    console.log(err);
                });
        }

        fetchData();
        return () => abortController.abort();
    }, [params, refresh]);


    const actions = useOutletContext();

    useEffect(() => {
        let actions2 = [
            {
                key: "mergeProject",
                text: "Połącz Projekt",
                iconProps: { iconName: "MergeDuplicate" },
                onClick: () => setMergeProject(params.id),
            },
            {
                key: "addChecklist",
                text: "Dodaj Punkt Kontrolny",
                iconProps: { iconName: "CheckList" },
                onClick: () => setAddChecklist(params.id),
            },
            {
                key: "addFee",
                text: "Dodaj Opłatę",
                iconProps: { iconName: "Money" },
                onClick: () => setAddFee(project.transaction_id),
            },
            {
                key: "addSchedule",
                text: "Dodaj Harmonogram",
                iconProps: { iconName: "Timeline" },
                onClick: () => setAddPaymentSchedule(true),
            },
            {
                key: "addPayment",
                text: "Dodaj Płatność",
                iconProps: { iconName: "PaymentCard" },
                onClick: () => setAddPayment(true),
            },
            {
                key: "addAddon",
                text: "Dodaj Dodatek",
                iconProps: { iconName: "WebAppBuilderFragmentCreate" },
                onClick: () => setAddAddon(params.id),
            },
            {
                key: "addDocument",
                text: "Dodaj Dokument",
                iconProps: { iconName: "TextDocument" },
                onClick: () => setAddDocument(params.id),
            },
            {
                key: "generateDocument",
                text: "Generuj Dokument",
                iconProps: { iconName: "Generate" },
                onClick: () => setGenerateDocument(params.id),
            },
            {
                key: "editProject",
                text: "Edytuj Projekt",
                iconProps: { iconName: "Edit" },
                onClick: () => setEditProject({ id: params.id, account: project.project_account, ...project }),
            },
        ];
        if (project.transaction_id !== null) {
            actions2.push({
                key: "editTransaction",
                text: "Edytuj Transakcje",
                iconProps: { iconName: "SetAction" },
                onClick: () => setEditTransaction({
                    id: project.transaction_id,
                    net_value: project.transaction_net_value,
                    vat: project.transaction_vat,
                    gross_value: project.transaction_gross_value,
                    until: project.reserved_until,
                    reservation_date: project.reservation_date,
                    reservation_number: project.reservation_number,
                    transaction_date: project.transaction_date,
                    transaction_number: project.transaction_number,
                    transfer_date: project.transfer_date,
                    finalization_date: project.finalization_date,
                    finalization_number: project.finalization_number,
                    final_divider: project.final_divider,
                    shares: project.shares,
                })
            });
        }
        actions(actions2);
        return actions;
    }, [project, refresh]);

    const [editTransaction, setEditTransaction] = useState(false);
    const [editProject, setEditProject] = useState(false);
    const [addAddon, setAddAddon] = useState(false);
    const [addDocument, setAddDocument] = useState(false);
    const [addPaymentSchedule, setAddPaymentSchedule] = useState(false);
    const [addPayment, setAddPayment] = useState(false);
    const [addChecklist, setAddChecklist] = useState(false);
    const [addFee, setAddFee] = useState(false);
    const [generateDocument, setGenerateDocument] = useState(false);
    const [mergeProject, setMergeProject] = useState(false);

    const scheduleSummary = Math.round(schedules.reduce((a, v) => a + parseFloat(v.value), 0.0) * 100) / 100;
    const theme = getTheme();
    const style = {
        root: {
            alignItems: "middle",
            flexDirection: "column",
            display: "flex",
            height: 340,
            justifyContent: "middle",
            overflow: "hidden",
            width: 400,
            boxShadow: theme.effects.elevation8,
            borderTopWidth: 8,
            borderTopColor: SharedColors.gray10,
            borderTopStyle: "solid",
            margin: 12,
        },
    };
    const personData = project.person ? (<>
        <p style={{
            fontSize: FontSizes.size24,
            fontWeight: FontWeights.light,
            height: 30,
            margin: 5,
        }}>{project.person}</p>
        <p style={{
            fontSize: FontSizes.size24,
            fontWeight: FontWeights.light,
            height: 30,
            margin: 5,
        }}>tel. {project.phone}</p>
        <p style={{ fontSize: FontSizes.size24, fontWeight: FontWeights.light, height: 90, margin: 5 }}>email. <a
            href={`mailto:${project.email}`}>{project.email}</a></p>
    </>) : "";

    const formatSize = () => {
        const divider = project.divider ? (<>{parseFloat(project.divider).toString()} m<sup>2</sup></>) : "";
        const whole = project.whole ? (<>{parseFloat(project.whole).toString()} m<sup>2</sup></>) : "";
        if (divider === "" && whole === "") {
            return "";
        }
        return (<>{divider} / {whole}</>);
    };
    const subtitle = [
        clearTextInfo(project.venture, ""),
        clearTextInfo(params.id, "ID:"),
    ];
    const _refresh = () => setRefresh((prev) => prev + 1);


    return (
        <AppContent
            title={project.name}
            subtitle={joinTextInfo(subtitle)}
            backTo={`/venture/${project.venture_id}`}
            delete={(<DeleteProject id={params.id}
                                    onSuccess={() => props.history.push(`/venture/${project.venture_id}`)} />)}
        >
            <Stack horizontal style={{ marginTop: 20 }} wrap horizontalAlign="space-around">
                <Stack.Item styles={style} grow={2}>
                    <h5 style={{
                        fontSize: FontSizes.size16,
                        fontWeight: FontWeights.light,
                        color: NeutralColors.gray100,
                        height: 20,
                        margin: 10,
                    }}>{formatSize()}</h5>
                    {personData}

                    <p style={{ fontSize: FontSizes.size24, fontWeight: FontWeights.light, height: 30, margin: 5 }}>
                        {project.reservation_number && `Rezerwacja: ${project.reservation_number}`}
                    </p>
                    <p style={{
                        fontSize: FontSizes.size24,
                        fontWeight: FontWeights.light,
                        height: 30,
                        margin: 5,
                    }}>{project.transaction_number && `Umowa: ${project.transaction_number}`}</p>
                    {project.transaction_id && <DeleteTransaction id={project.transaction_id} onSuccess={_refresh} />}
                </Stack.Item>
                <Stack.Item>
                    <Card color={SharedColors.cyan10} title={`Wartość Pierwotna ${netGrossFieldName()}`}
                          value={project[netGrossField("project_")]} />
                    <Card color={SharedColors.greenCyan10} title={`Wartość Transakcji ${netGrossFieldName()}`}
                          value={project[netGrossField("transaction_")] ?? project[netGrossField("project_")]} />
                    <Card color={SharedColors.yellowGreen10} title="Suma Rat" value={scheduleSummary} />

                </Stack.Item>
            </Stack>
            <Stack horizontal style={{ marginTop: 20 }} wrap horizontalAlign="space-between">
                <Stack.Item>
                    <Card color={SharedColors.yellow10} title="Opłacono" value={project.paid} />
                </Stack.Item><Stack.Item>
                <Card color={SharedColors.orange10} title="Pozostało" value={project.left} />
            </Stack.Item><Stack.Item>
                <Card color={SharedColors.redOrange10} title="Opóźnione" value={project.outdate_payments} />
            </Stack.Item>

            </Stack>
            <Stack vertical>
                <ProjectDocumentList data={documents} />
                <ProjectAddonList data={addons} refresh={_refresh} netGross={netGross} />
                <PaymentScheduleList data={schedules} refresh={_refresh} />
                <PaymentList data={payments} refresh={_refresh} />
                <ProjectFeesList data={fees} refresh={_refresh} netGross={netGross} />
                <ProjectCounterList data={counters} refresh={_refresh} />
                <ProjectCheckList data={checklist} update={setChecklist} />
                <ProjectTasks data={tasks} />
                <InvoiceList data={invoices} refresh={_refresh} netGross={netGross} />
            </Stack>
            <EditProject edit={editProject} dismissPanel={() => setEditProject(false)} onSuccess={_refresh} />
            <AddPaymentSchedule isOpen={addPaymentSchedule} dismissPanel={() => setAddPaymentSchedule(false)}
                                onSuccess={_refresh} transactionId={project.transaction_id} />
            <AddPayment add={addPayment} dismissPanel={() => setAddPayment(false)} onSuccess={_refresh}
                        transactionId={project.transaction_id} />
            <EditTransaction edit={editTransaction} dismissPanel={() => setEditTransaction(false)}
                             onSuccess={_refresh} />
            <AddProjectAddon add={addAddon} dismissPanel={() => setAddAddon(false)} onSuccess={_refresh} />
            <AddChecklist add={addChecklist} dismissPanel={() => setAddChecklist(false)} onSuccess={_refresh} />
            <AddProjectDocument add={addDocument} dismissPanel={() => setAddDocument(false)} onSuccess={_refresh} />
            <AddAdditionalFee add={addFee} dismissPanel={() => setAddFee(false)} onSuccess={_refresh} />
            <MergeProject add={mergeProject} dismissPanel={() => setMergeProject(false)}
                          onSuccess={() => props.history.push(`/venture/${project.venture_id}`)} />
            <GenerateProjectDocument add={generateDocument} dismissPanel={() => setGenerateDocument(false)}
                                     onSuccess={_refresh} />
        </AppContent>
    );
}

export default Project;